import { LayoutConfig, LayoutSlotConfig, SlotConfig, SlotGroup } from '@spartacus/storefront';

const plpTemplate: SlotConfig | SlotGroup | LayoutSlotConfig = {
  slots: [
    'PLPCounter',
    'ProductTopRefinementsA',
    'ProductTopRefinementsB',
    'ProductTopRefinementsC',

    'ProductLeftRefinements',

    'ProductListSlot',
    'ProductGridSlot',
    'SearchResultsListSlot',
    'SearchResultsGridSlot',

    'NoContent',
    'ProductBottomRefinements',
  ],
};

export const layoutConfig: LayoutConfig = {
  // deferredLoading: {
  //   strategy: DeferLoadingStrategy.DEFER,
  //   intersectionMargin: '50px',
  // },
  layoutSlots: {
    preHeader: {
      lg: {
        slots: [''],
      },
      slots: ['PreHeader'],
    },
    headerAuxMobile: {
      lg: {
        slots: [''],
      },
      slots: ['MiniCart'],
    },
    beforeHeader: {
      lg: {
        slots: ['SiteContext', 'SiteLinks'],
      },
      slots: ['SiteContext', 'SiteLinks'],
    },
    siteLogo: {
      lg: {
        slots: ['SiteLogo'],
      },
      slots: [''],
    },
    headerAux: {
      lg: {
        slots: ['SearchBox', 'SiteLogin', 'MiniCart'],
      },
      slots: [''],
    },
    navigation: {
      lg: { slots: ['NavigationBar'] },
      slots: ['NavigationBar'],
    },
    subMenuMobile: {
      slots: ['SiteLogo', 'SearchBox'],
    },

    bottomHeader: {
      lg: {
        slots: ['BottomHeaderSlot'],
      },
      slots: ['BottomHeaderSlot'],
    },

    footer: {
      slots: ['Footer'],
    },

    LandingPage2Template: {
      slots: ['Section1', 'Section2', 'Section3'],
    },

    ContentPage1Template: {
      lg: {
        slots: ['BottomHeaderSlotForPage', 'Section2A', 'Section2B'],
      },
      slots: ['BottomHeaderSlotForPage', 'Section2A', 'Section2B'],
    },

    CategoryPageTemplate: {
      slots: ['TopContent', 'CenterLeftContentSlot', 'CenterRightContentSlot'],
    },

    ProductListPageTemplate: plpTemplate,
    ProductGridPageTemplate: plpTemplate,
    SearchResultsListPageTemplate: plpTemplate,
    SearchResultsGridPageTemplate: plpTemplate,

    ProductDetailsPageTemplate: {
      slots: [
        'ProductTopSection',
        'ProductSideBar',
        'ProductGallery',
        'Summary',
        // 'UpSelling',
        // 'CrossSelling',
        'Tabs',
        'ProductBottomSection',
      ],
    },

    CartPageTemplate: {
      lg: {
        slots: [
          'TopContent',
          'TopSecondaryActions',
          'CenterLeftContentSlot',
          'CenterRightContentSlot',
          'EmptyCartMiddleContent',
        ],
      },
      slots: [
        'TopContent',
        'TopSecondaryActions',
        'CenterRightContentSlot',
        'CenterLeftContentSlot',
        'CenterRightContentSlot',
        'EmptyCartMiddleContent',
      ],
    },

    AccountPageTemplate: {
      lg: {
        slots: ['HeaderLinks', 'BodyContent'],
      },
      slots: ['BodyContent'],
    },

    LoginPageTemplate: {
      slots: ['LeftContentSlot', 'RightContentSlot'],
    },

    ErrorPageTemplate: {
      slots: ['TopContent', 'MiddleContent', 'BottomContent'],
    },
    OrderConfirmationPageTemplate: {
      slots: ['BodyContent', 'SideContent'],
    },
    MultiStepCheckoutSummaryPageTemplate: {
      slots: ['TopContent', 'BodyContent', 'SideContent', 'BottomContent'],
    },
    CheckoutLoginPageTemplate: {
      slots: ['RightContentSlot'],
    },
    MyAccountViewPageTemplate: {
      slots: ['LeftContentSlot', 'RightContentSlot'],
    },

    TwoColumnPageTemplate: {
      slots: ['FullSizeTop', 'Left', 'Right', 'FullSizeBottom'],
    },

    ThreeColumnPageTemplate: {
      slots: ['FullSizeTop', 'Column1', 'Column2', 'Column3', 'FullSizeBottom'],
    },
  },
};

export const defaultStoreFinderLayoutConfig: LayoutConfig = {
  layoutSlots: {
    StoreFinderPageTemplate: {
      slots: ['MiddleContent', 'SideContent'],
    },
  },
};
